export const UPC = 'upc';
export const COLORS = 'colors';
export const SELECTED_COLOR = 'selectedColor';
export const PRICE = 'price';
export const SIZES = 'sizes';
export const SELECTED_SIZE = 'selectedSize';
export const TYPE = 'type';
export const SELECTED_TYPE_ID = 'selectedTypeId';

export default {
  UPC,
  COLORS,
  SELECTED_COLOR,
  PRICE,
  SIZES,
  SELECTED_SIZE,
  TYPE,
  SELECTED_TYPE_ID,
};
